import * as React from "react";
import CreateApartmentForm from "../../components/Forms/Apartment/FlowForm/FlowForm";

export default function CreateApartment() {
  return <CreateApartmentForm />;
}
